import React from "react"
import { useParams } from "react-router-dom"

import useGetDoc from "../../hooks/useGetDoc"

//comps
import { LoaderSmall } from "../../components/Loaders"
import FormWrapper from "./FormWrapper"
import logger from "../../services/logger"

export default function Edit() {
  const { docId } = useParams()
  const [loading, error, data] = useGetDoc("users", docId)
  if (error) {
    return (
      <div>
        <h2>Error when fetching.</h2>
      </div>
    )
  }

  logger.debug("User edit data loaded")

  if (loading) return <LoaderSmall />

  const handleData = {
    ...data,
    ref_organization: data.ref_organization.id,
  }

  const handleType = () => {
    if (data.ref_organization.id === "hfma") {
      return "edit-hfma"
    }
    return "edit"
  }

  return (
    <div className="container">
      <h1>Edit User</h1>
      <FormWrapper type={handleType()} docValues={handleData} />
    </div>
  )
}
